'use strict';

var React = require('react');

var SvgImagesMajor = function SvgImagesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 16a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1h-14a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14zm-12.574-2c-.253 0-.426-.191-.426-.396 0-.08.026-.162.083-.236l3.046-3.24a.448.448 0 0 1 .617-.009l1.397 1.481 2.623-3.825a.446.446 0 0 1 .72.016l3.462 5.609c.154.272-.052.6-.377.6h-11.145zm4.574-9a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-11-.5a1.5 1.5 0 0 1 1.5-1.5h.5v15h15v.5a1.5 1.5 0 0 1-1.5 1.5h-14a1.5 1.5 0 0 1-1.5-1.5v-14z"
  }));
};

exports.SvgImagesMajor = SvgImagesMajor;
